module.exports = __webpack_public_path__ + "img/32201D_613C3C_563533_8C655F-256px.ea09c1fb.png";